module.exports = __webpack_public_path__ + "img/introduce_2.c97df94c.png";